import Vue from "vue";
import Utils from "./services/utils-service.js";
import RTQ from "./services/rtq-service.js";
import Funnel from "./services/funnel-service.js";
import Driver from "./services/driver-service.js";
import VehicleModule from "./modules/vehicle-module.js";
import DriverModule from "./modules/driver-module.js";
import router from "./router.js";
import RTQModule from "./modules/rtq-module.js";
import RVModule from "./modules/rv-module.js";
import PetModule from "./modules/pet-module.js";
import { throwError } from "./errors";
// import cssVariables from '../../../sass/template-set/tacqu_v3/_variables.module.scss';//WIP - Gabriel
// console.log("cssVariables: ",cssVariables);//WIP - Gabriel

Vue.use(Vuex)

import gtmPlugin from "./vuex-plugins/gtmPlugin.js";

const store = new Vuex.Store({
    strict: true,//strictly for development purposes, remove for prod.
    state: {
        funnel: {
            elements: {},
            idsMap: {
                sidebar_features: [],
                system_responses: [],
                experiences: [],
                pages: {},
                pages_sequence: [],
                routes: []
            }
        },
        factory: {
            loading: {
                status: true,
                text: 'Loading Main Page'
            },
            disable_next: false,
            complete_percent: 0,
            complete_pages: [],
            template_set: "",
            partner_logo: "",
            partner_logo_alt: "",
            base_logo: "",
            base_logo_alt: "",
            save_payload: {},
            back: false,
            // css_variables:cssVariables //WIP - Gabriel
        },
        active_page: '',//moving this to factory causes a bug with validation needs to be figured out and moved -G
        active_page_uid:'',
        ss_key: null,
        window: {
            width: window.innerWidth,
            height: window.innerHeight
        },
        notificationObj: {
            // message: '',
            // type: 'success',// info | warning | danger | success | primary
            // title: '',
            // icon:"icon",
            // verticalAlign: 'bottom',
            // horizontalAlign: 'center',
            // showClose:false,
            // closeOnClick:false
        }
    },
    getters: {
        window: state => state.window, //used for resize events
        funnel: state => state.funnel,
        loading: state => state.factory.loading,
        active_page: state => state.active_page,
        active_page_uid: state => state.active_page_uid,
        complete_percent: state => state.factory.complete_percent,
        complete_pages: state => state.factory.complete_pages,
        factory: state => state.factory,
        notification: state => state.notificationObj,
        disable_next: state => state.factory.disable_next,
        //progress: state => state.factory.progress
        template_set: state => state.factory.template_set, //used for generating template specific logos
        partner_logo: state => state.factory.partner_logo, //loads existing logo
        partner_logo_alt: state => state.factory.partner_logo_alt, //loads existing logo  alt description
        base_logo: state => state.factory.base_logo, //loads base logo urls from db for partnered clients
        base_logo_alt: state => state.factory.base_logo_alt, //loads base logo alt description
        custom_template_data: state => state.factory.custom_template_data,
        current_lob: state => state.funnel.elements.in_fx_base_path.value,
    },
    setters: {

    },
    mutations: {
        SET_LOADING_STATUS: function (state, updatedValue) {
            state.factory.loading.status = updatedValue
        },
        SET_LOADING_TEXT: function (state, updatedValue) {
            state.factory.loading.text = updatedValue
        },
        SET_SAVING_STATUS: function (state, updatedValue) {
            state.factory.saving = updatedValue
        },
        TRIGGER_ANALYTICS(state, data) {
            console.log('run analytics pageview');
        },
        UPDATE_SAVE_PAYLOAD(state, data) {
            for (const key in data.payload) {
                Vue.set(state.factory.save_payload, key, key);
            }

        },
        UPDATE(state, data) {
            Vue.set(state, data.prop, data.val);
        },
        UPDATE_NOTIFICATION(state, data) {
            Vue.set(state, data.prop, data.val);
        },
        INIT(state, data) {
            if (!Utils.isObjEmpty(data.funnel))
                state.funnel = data.funnel;
            if (!Utils.isEmpty(data.reset_lc_zip)) {
                if (Utils.isTruthy(data.reset_lc_zip)) {
                    localStorage.removeItem('zipcode');
                } else {
                    localStorage.setItem('zipcode', data.reset_lc_zip);
                    if (!Utils.isTruthy(data.skip_init_intro_route_reset))
                        router.push('/intro').catch(() => { });
                }
            }
        },
        UPDATE_FACTORY_ITEMS(state, factoryItems) {
            for (const key in factoryItems) {
                Vue.set(state.factory, key, factoryItems[key]);
            }
        },
        UPDATE_FUNNEL_ELEM(state, data) {
            Vue.set(state.funnel.elements[data.iuid], data.key, data.val)
        },
        UPDATE_FUNNEL_ELEM_OPTION(state, data) {
            Vue.set(state.funnel.elements[data.iuid].options[data.index], data.key, data.val)
        },
        ADD_ELEMENTS(state, data) {
            for (const uid in data) {
                Vue.set(state.funnel.elements, uid, data[uid]);
            }
        },
        DELETE_ELEMENTS(state, data) {
            for (const uid of data) {
                Vue.delete(state.funnel.elements, uid);
            }
        },
        ADD_PAGES(state, addPageMaps) {
            for (const puid in addPageMaps) {
                Vue.set(state.funnel.idsMap.pages, puid, addPageMaps[puid]);
            }
        },
        DELETE_PAGES(state, delPages) {
            for (const puid of delPages) {
                Vue.delete(state.funnel.idsMap.pages, puid);
            }
        },
        ADD_ROUTES(state, addRoutes) {
            Vue.set(state.funnel.idsMap, 'routes', addRoutes);
        },
        ADD_ROUTES_TO_POS(state, routesObj) {
            const routes = state.funnel.idsMap.routes;
            for (const prop in routesObj) {
                if (routes.indexOf(routesObj[prop].route) == -1) {
                    const pos = routes.indexOf(routesObj[prop].refRoute);
                    const i = routesObj[prop].pos == 'after' ? pos + 1 : routesObj[prop].pos == 'before' ? pos - 1 : pos;
                    state.funnel.idsMap['routes'].splice(i, 0, routesObj[prop].route);
                }
            }
        },
        DELETE_ROUTES_SEQ(state, delRoutesArr) {
            for (const i in delRoutesArr) {
                const delIndx = state.funnel.idsMap.routes.indexOf(delRoutesArr[i]);

                if (delIndx != -1) {
                    state.funnel.idsMap['routes'].splice(delIndx, 1);
                }
            }
        },
        ADD_SIDEBAR_FEATURES(state, addSidebarFeatures) {
            Vue.set(state.funnel.idsMap, 'sidebar_features', addSidebarFeatures);
        },
        ADD_PAGE_SEQ(state, data) {
            state.funnel.idsMap['pages_sequence'].splice(data.i, 0, data.puid);
        },
        ADD_PAGE_SEQ_TO_POS(state, pgSeqObj) {
            const pgSeq = state.funnel.idsMap.pages_sequence;
            for (const prop in pgSeqObj) {
                if (pgSeq.indexOf(pgSeqObj[prop].puid) == -1) {
                    if (typeof pgSeqObj[prop].refUids === 'object') {
                        const refUids = pgSeqObj[prop].refUids;
                        const len = refUids.length;
                        let u = 0;
                        while (pgSeq.indexOf(refUids[u]) == -1 && u < len) {
                            u++;
                        }
                        const pos = pgSeq.indexOf(refUids[u]);
                        const i = pgSeqObj[prop].pos == 'after' ? pos + 1 : pgSeqObj[prop].pos == 'before' ? pos : pos;
                        state.funnel.idsMap['pages_sequence'].splice(i, 0, pgSeqObj[prop].puid);
                    }
                }
            }
        },
        UPDATE_PAGES_SEQ(state, updatePgSeq) {
            state.funnel.idsMap.pages_sequence = updatePgSeq
        },
        DELETE_PAGE_SEQ(state, delPgSeq) {
            for (const i in delPgSeq) {
                const delIndx = state.funnel.idsMap.pages_sequence.indexOf(delPgSeq[i]);
                if (delIndx != -1) {
                    state.funnel.idsMap['pages_sequence'].splice(delIndx, 1);
                }
            }
        },
        UPSERT_ADHOC_SEQ(state, data) {
            state.funnel.idsMap.adhoc_sequence = data.adhoc_sequence;
        },
        CREATE_SECTION_SEQS(state, scSeqMaps) {
            for (const i in scSeqMaps) {
                const scSeqMap = scSeqMaps[i];
                Vue.delete(state.funnel.idsMap.pages[scSeqMap.puid], 'sections_sequence');
                Vue.set(state.funnel.idsMap.pages[scSeqMap.puid], 'sections_sequence', []);
                for (const suid in scSeqMap.sseq) {
                    Vue.set(state.funnel.idsMap.pages[scSeqMap.puid].sections_sequence, suid, scSeqMap.sseq[suid]);
                }
            }
        },
        CREATE_SECTIONS(state, scMaps) {
            for (const i in scMaps) {
                const scMap = scMaps[i];
                Vue.delete(state.funnel.idsMap.pages[scMap.puid], 'sections');
                Vue.set(state.funnel.idsMap.pages[scMap.puid], 'sections', {});
                for (const suid in scMap.sections) {
                    Vue.set(state.funnel.idsMap.pages[scMap.puid].sections, suid, scMap.sections[suid]);
                }
            }
        },
        ADD_SECTION_SEQS(state, addScSeqMaps) {
            for (const indx in addScSeqMaps) {
                const addScSeqMap = addScSeqMaps[indx];
                const scSeq = state.funnel.idsMap.pages[addScSeqMap.puid].sections_sequence;
                const len = scSeq.length;
                for (const j in addScSeqMap.sseq) {
                    const suid = addScSeqMap.sseq[j];
                    const i = len + parseInt(j);
                    if (scSeq.indexOf(suid) == -1) {
                        Vue.set(state.funnel.idsMap.pages[addScSeqMap.puid].sections_sequence, i, suid);
                    }
                }
            }
        },
        ADD_SECTIONS(state, addScMaps) {
            for (const i in addScMaps) {
                const addScMap = addScMaps[i];
                for (const suid in addScMap.sections) {
                    Vue.set(state.funnel.idsMap.pages[addScMap.puid].sections, suid, addScMap.sections[suid]);
                }
            }
        },
        ADD_ELEMENT(state, data) {
            Vue.set(state.funnel.elements, data.iuid, data.val);
        },
        DELETE_ELEMENT(state, uid) {
            Vue.delete(state.funnel.elements, uid);
        },
        UPDATE_SECTION_SEQ(state, data) {
            state.funnel.idsMap.pages[data.puid].sections_sequence = data.val;
        },
        ADD_SECTION(state, data) {
            Vue.set(state.funnel.idsMap.pages[data.puid].sections, data.suid, data.val);
        },
        DELETE_INPUT_SEQ_ITEM(state, data) {
            Vue.delete(state.funnel.idsMap.pages[data.puid].sections[data.suid]['inputs_sequence'], data.iuid);
        },
        UPDATE_INPUT_SEQ(state, data) {
            Vue.set(state.funnel.idsMap.pages[data.puid].sections[data.suid], 'inputs_sequence', data.iseq);
        },
        CREATE_INPUT_SEQS(state, crInSeqMaps) {
            for (const i in crInSeqMaps) {
                const crIuidMap = crInSeqMaps[i];
                const section = state.funnel.idsMap.pages[crIuidMap.puid].sections[crIuidMap.suid];
                if (!Utils.isObjEmpty(section))
                    Vue.delete(section, 'inputs_sequence');
                Vue.set(section, 'inputs_sequence', []);
                for (const indx in crIuidMap.iseq) {
                    const iuid = crIuidMap.iseq[indx];
                    Vue.set(section.inputs_sequence, indx, iuid);
                }
            }
        },
        UPDATE_INPUT_SEQS(state, inSeqMaps) {
            for (const i in inSeqMaps) {
                const iuidMap = inSeqMaps[i];
                for (const indx in iuidMap.iseq) {
                    const iuid = iuidMap.iseq[indx];
                    Vue.set(state.funnel.idsMap.pages[iuidMap.puid].sections[iuidMap.suid].inputs_sequence, indx, iuid);
                }
            }
        },
        UPDATE_RTQ_INPUT_SEQS(state, inSeqMaps) {
            for (const i in inSeqMaps) {
                const iuidMap = inSeqMaps[i];
                const inSeq = state.funnel.idsMap.pages[iuidMap.puid].sections[iuidMap.suid].inputs_sequence;
                const cLen = inSeq.length;
                const len = iuidMap.iseq.length;
                for (const indx in iuidMap.iseq) {
                    const iuid = iuidMap.iseq[indx];
                    Vue.set(inSeq, indx, iuid);
                }
                if (cLen > len)
                    inSeq.splice(len - cLen);
            }
        },
        DELETE_INPUT_SEQS(state, delInSeqMap) {
            for (const i in delInSeqMap) {
                const pathMap = delInSeqMap[i];
                const inSeq = state.funnel.idsMap.pages[pathMap.puid].sections[pathMap.suid].inputs_sequence;
                for (const indx in pathMap.iseq) {
                    const iuid = pathMap.iseq[indx];
                    const delIndx = inSeq.indexOf(iuid);
                    if (delIndx != -1) {
                        inSeq.splice(delIndx, 1);
                    }
                }
            }
        },
        SET_ADDRESS_CITY_OPTIONS(state, data) {

        },
        SET_ZIP(state, data) {
            state.factory.zipcode = data
        },
        UPDATE_FIELD(state, data) {
            if (!state.funnel.elements[data.uuid].value) {
                state.funnel.elements[data.uuid].value = ''
            }
            state.funnel.elements[data.uuid].value = data.updatedValue
        },
        UPDATE_CHECKBOX_DATA(state, data) {

            if (data.actionType == 'add') {

                if (Array.isArray(state.funnel.elements[data.uuid].value)) {
                    state.funnel.elements[data.uuid].value.push(data.value)
                }
                else {
                    if (state.funnel.elements[data.uuid].value.indexOf(data.value) > -1) { return }
                    state.funnel.elements[data.uuid].value = data.value;
                }
            } else {
                if (Array.isArray(state.funnel.elements[data.uuid].value)) {
                    const checkboxVal = state.funnel.elements[data.uuid].value.filter(checkbox => {
                        return checkbox != data.value
                    });
                    state.funnel.elements[data.uuid].value = checkboxVal;
                }
                else
                    state.funnel.elements[data.uuid].value = "";
            }
        },
        UPDATE_MULTISELECT_DATA(state, data) {

            if (data.actionType == 'add') {

                if (Array.isArray(state.funnel.elements[data.uuid].value)) {
                    state.funnel.elements[data.uuid].value.push(data.value)
                }
                else {
                    if (state.funnel.elements[data.uuid].value.indexOf(data.value) > -1) { return }
                    state.funnel.elements[data.uuid].value = data.value;
                }
            } else {
                if (Array.isArray(state.funnel.elements[data.uuid].value)) {
                    const checkboxVal = state.funnel.elements[data.uuid].value.filter(checkbox => {
                        return checkbox != data.value
                    });
                    state.funnel.elements[data.uuid].value = checkboxVal;
                }
                else
                    state.funnel.elements[data.uuid].value = "";
            }
        },
        GET_CURRENT_PAGE(state) {
            var currentRoute = router.app._route.fullPath;

            var activePage = Object.keys(state.funnel.elements).filter(elementKey => {
                if (state.funnel.elements[elementKey]) {
                    state.funnel.elements[elementKey].page_route == currentRoute.toString();
                }
            });

            var activePageUID = Object.keys(state.funnel.elements).filter(elementKey => {
                if (state.funnel.elements[elementKey] && (state.funnel.elements[elementKey].page_route == currentRoute.toString())) {
                    return state.funnel.elements[elementKey].uid
                }
            });

            if (!state.funnel.idsMap.pages_sequence) { console.log('%cALERT:Syntax error on the elements JSON. ', 'color: white; background: red; font-size: 30px'); }
            var page_index = state.funnel.idsMap.pages_sequence.indexOf(activePage)

            state.current_page = page_index
            state.active_page = activePage
            state.active_page_uid = activePageUID
        },
        // SET_CURRENT_PAGE(state, data) {
        //     // {pageIndex, pageId}
        //     // state.funnel.elements[state.active_page].page_status = 'complete'
        //     // state.funnel.elements[data.pageId].page_status = 'active'
        //     state.active_page = data.pageId
        //     state.current_page = data.pageIndex
        //     router.push({ path: state.funnel.elements[data.pageId].page_route })
        //     fs.setMetadata()
        // },
        SET_CUSTOM_TEMPLATE_DATA(state, data) {
            state.custom_template_data = data
        },

        //set template for client
        SET_TEMPLATE_SET(state, template_set) {
            state.factory.template_set = template_set
        },

        SET_PARTNER_LOGO(state, partner_logo) {
            state.factory.partner_logo = partner_logo;
        },
        SET_PARTNER_LOGO_ALT(state, partner_logo_alt) {
            state.factory.partner_logo_alt = partner_logo_alt;
        },
        SET_BASE_LOGO(state, base_logo) {
            state.factory.base_logo = base_logo;
        },
        SET_BASE_LOGO_ALT(state, base_logo_alt) {
            state.factory.base_logo_alt = base_logo_alt;
        }
    },
    actions: {
        prefillFunnel: function name(context) {
            const qryParam = router.app.$route.query;
            if (!Utils.isEmpty(qryParam) && !Utils.isEmpty(qryParam.pf)) {

                const reqType = qryParam.pf;
                var errorCount = 0;
                $.ajax({
                    type: 'POST',
                    url: `/api?req=${reqType}&action=init-app`,
                    data: {},
                    beforeSend: function () { },
                    success: function (res) {
                        console.log('Funnel Prefill: ', res);
                        if (res != null && Object.keys(res).length > 0) {

                            context.commit('INIT', res);
                            context.commit('UPDATE_FACTORY_ITEMS', res.factory);

                            const fs = new Funnel({ ctx: context, router: router });
                            fs.completePageLoading();

                            fs.actionResponseHandler(res.actions);

                            fs.persistZipCode();

                            fs.bypassActionHandler(res);

                            if (!Utils.isObjEmpty(res.actions)) {
                                if (!Utils.isEmpty(res.actions.redirect)) {
                                    router.push(res.actions.redirect.url).catch(() => { });
                                }
                            }
                        }
                    },
                    error: function (xhr, textStatus, errorThrown) {
                        errorCount++

                        throwError(new Error(`prefillFunnel error: ${textStatus}`), { qryParam: JSON.stringify(qryParam), context: context, reqType: reqType, errorLocation: "prefillFunnel", xhr: JSON.stringify(xhr), textStatus: textStatus, errorThrown: errorThrown, data: JSON.stringify(data) })

                        if (errorCount <= 3) {
                            setTimeout(function () {
                                context.dispatch('prefillFunnel');
                            }, 3000)
                        }
                        else {
                            // Do something here
                        }
                    }
                });
            }
        },
        getFunnel: function name(context) {
            const fp = router.app._route.fullPath;
            console.log('This is the full path', fp);

            const params = new Proxy(new URLSearchParams(window.location.search), {
                get: (searchParams, prop) => searchParams.get(prop),
            });

            if (params['dev_show_all_questions']) {
                console.log('developer pre-cookie: ', document.cookie);
                document.cookie = "dev_show_all_questions=1";
                console.log('developer post-cookie: ', document.cookie);
            }

            var errorCount = 0

            $.ajax({
                type: 'POST',
                url: `/api?req=quoter&action=init-app&fullPath=${fp}`,
                data: {},
                beforeSend: function () {

                },
                success: function (res) {
                    // console.log('Auto Funnel Init: ', res);
                    // if (localStorage.getItem("vuex") != null){return}
                    if (res != null && Object.keys(res).length > 0) {

                        let init = res;
                        let factoryItems = res.factory;
                        if (res.data && Object.keys(res.data).length > 0) {
                            init = res.data.init;
                            factoryItems = res.data.factoryItems;
                        }

                        context.commit('INIT', init);
                        context.commit('UPDATE_FACTORY_ITEMS', factoryItems);
                        //move this to the routing function instead of waiting to get data success
                        context.commit('GET_CURRENT_PAGE');
                        // context.dispatch('calculateCompletePercent');

                        context.commit('UPDATE_FACTORY_ITEMS', factoryItems);
                        //quotableLobs vvv

                        const fs = new Funnel({ ctx: context, router: router });
                        fs.actionResponseHandler(res.actions);

                        fs.completePageLoading();

                        const queryString = window.location.search;
                        const urlParams = new URLSearchParams(queryString);
                        const bns = urlParams.get('bns');
                        //console.log(`BNS is ${bns}. Zipcode value is ${context.getters.funnel.elements.in_address_zip.value}`);
                        if (bns) {
                            localStorage.removeItem('zipcode');
                            context.commit('UPDATE_FUNNEL_ELEM', { iuid: 'in_address_zip', key: 'value', val: '' });
                            router.push('/zip-code').catch(() => { });
                        }

                        let zipcode = ""

                        if (context.getters.funnel.elements.in_address_zip.value != "") {
                            zipcode = context.getters.funnel.elements.in_address_zip.value
                        }
                        else {
                            // Check if a zip exists in the query string
                            //const queryString = window.location.search;
                            //const urlParams = new URLSearchParams(queryString);
                            zipcode = urlParams.get('zipcode');
                        }

                        if (context.getters.zipcode || zipcode) {
                            const zip = context.getters.zipcode || zipcode;

                            context.commit('UPDATE_FUNNEL_ELEM', { iuid: 'in_address_zip', key: 'value', val: zip });
                            // console.log(context.state.funnel.elements[context.getters.active_page].page_route);
                            // router.push({ path: context.state.funnel.elements[context.getters.active_page].page_route })
                            // If a zip was entered on the content site, bypass the zip code page
                            if (router.app._route.fullPath === '/zip-code') {
                                const event = { target: { type: 'submit' } };
                                const funnelService = new Funnel({ ctx: context });
                                funnelService.router = router;
                                funnelService.updateZip(event, context.getters.funnel.elements.in_address_zip);
                            }
                        }
                        //const fs = new Funnel({ ctx: context, router: router });
                        // fs.setMetadata()
                    }
                    // context.commit('UPDATE_NOTIFICATION', { message: "dynamic Message from store" })// notification test


                },
                error: function (xhr, textStatus, errorThrown) {
                    errorCount++

                    throwError(new Error(`getFunnel error: ${fp} - ${textStatus}`), { errorLocation: "getFunnel", xhr: JSON.stringify(xhr), textStatus: textStatus, errorThrown: errorThrown, data: JSON.stringify(data) })

                    if (errorCount <= 3) {
                        setTimeout(function () {
                            context.dispatch('getFunnel');
                        }, 3000)
                    }
                    else {
                        // Do something here
                    }
                }
            });
        },
        updateField({ commit }, data) {
            commit('UPDATE_FIELD', data)
        },
        updateCheckboxData(context, data) {
            console.log("in updateCheckboxData")
            const actionType = data.target.checked ? 'add' : 'remove';
            const uuid = data.uuid
            const input = context.state.funnel.elements[uuid]
            const value = data.target.value
            const factory = context.state.factory
            if (typeof factory[uuid] === 'undefined') {
                factory[uuid] = {}
            }

            if (typeof factory[uuid][data.target.name] !== 'undefined') {
                const currentValues = new Set(context.state.funnel.elements[data.uuid].value);
                const oldVal = factory[uuid][data.target.name]
                if (currentValues.has(oldVal)) {
                    context.commit('UPDATE_CHECKBOX_DATA', { uuid, actionType: 'remove', value: oldVal });
                }
            }
            else {
                factory[uuid][data.target.name] = data.target.value;
            }

            if (actionType == 'add') {
                factory[uuid][data.target.name] = data.target.value;
            }
            else {
                delete factory[uuid][data.target.name];
            }
            context.commit('UPDATE_CHECKBOX_DATA', { uuid, actionType, value });

        },
        updateMultiselectData(context, data) {
            console.log("in multiselect")
            const oldVal = factory[uuid][data.target.name]

            if (currentValues.has(oldVal)) {
                console.log("deleting old val in multiselect")
                context.commit('UPDATE_CHECKBOX_DATA', { uuid, actionType: 'remove', value: oldVal });
            }
            context.commit('UPDATE_MULTISELECT_DATA', { uuid, value });
        },
        setAddressCity(context, city) {

        },
        calculateCompletePercent(context) {
            var total_pages = []

            context.getters.funnel.idsMap.pages_sequence.map(function (i) {
                total_pages.push(i)
            })

            var complete_pages = context.getters.complete_pages

            const fs = new Funnel({ ctx: context, router: router });
            total_pages.length = fs.getTotalPageCount(total_pages);

            total_pages = fs.reComputeTotaPagesPostQuoting(total_pages, complete_pages);

            var complete_percent = parseInt(complete_pages.length / total_pages.length * 100)

            // var incomplete_pages = complete_pages.filter(x => total_pages.includes(x));

            console.log('total pages: ', total_pages, 'complete pages: ', complete_pages);

            var currentRoute = router.app._route.path;

            console.log("COMPLETE PAGES: " + complete_pages.length);
            if (complete_pages.length < 2 && (currentRoute == "/zip-code" || currentRoute == "/intro")) {
                complete_percent = 0
                // this is a hack for the complete percent i placed it to expedite release off beta but we should look in depth -G
            }
            else if (currentRoute.indexOf('/disaster-thanks') > -1 || currentRoute.indexOf('/rtq') > -1 || currentRoute.indexOf('/rta') > -1 || complete_percent >= 100) {
                complete_percent = 100
                // this is a hack for the complete percent i placed it to expedite release off beta but we should look in depth -G
                //added /rta to this hack a year later but man I really should look into fixing this for real. 
                // added /disaster-thanks a few months later.... still need to fix this
            }

            context.commit('UPDATE_FACTORY_ITEMS', { complete_percent: complete_percent })
            $('.progress-bar.donut').removeClass('loading-progress');


        },
        save(context, data) {
            const fs = new Funnel({ ctx: context, router: router });
            const reqType = fs.getReqType(data.ctrl.puid);

            var errorCount = 0;
            var cast = '';

            $.ajax({
                type: 'POST',
                url: `/api?req=${reqType}&action=save${cast}`,
                data: data,
                beforeSend: function () {
                    fs.startPageLoading(data.ctrl.puid);
                },
                success: function (res) {
                    console.log('Auto Funnel Save: ', res);

                    if (res != null && Object.keys(res).length > 0) {

                        if (!Utils.isEmpty(res.success) && res.success == false) {
                            context.commit('SET_LOADING_STATUS', false);
                        }

                        fs.ajaxVuexResponseHandler(data, res);
                    }

                    const insuranceType = fs.ctx.getters.funnel.elements.in_insurance_type.value

                    if (data.ctrl.puid == 'pg_intro_customize' && fs.isBundle() && insuranceType.indexOf('HOME') != -1 && fs.ctx.getters.funnel.elements.in_home_prefill_permissions.value === "Yes") {
                        console.log("Fetching Home Prefill for bundle")
                        fs.fetchHomePrefill()
                    }

                    fs.completePageLoading(data.ctrl.puid);
                    context.dispatch('calculateCompletePercent');

                },
                error: function (xhr, textStatus, errorThrown) {
                    errorCount++

                    throwError(new Error(`save error: ${textStatus}`), { "errorLocation": "save", "xhr": JSON.stringify(xhr), "textStatus": textStatus, "errorThrown": errorThrown, data: JSON.stringify(data), context: JSON.stringify(context), reqType: reqType })

                    if (errorCount <= 3) {
                        setTimeout(function () {
                            context.dispatch('save', { factory: data.factory, ctrl: data.ctrl, payload: data.payload });
                        }, 3000)
                    }
                    else {
                        // Do something here
                    }
                }
            });
        },
        fetch(context, data) {
            const fs = new Funnel({ ctx: context, router: router });
            const reqType = fs.getReqType(data.ctrl.puid);
            var errorCount = 0;

            $.ajax({
                type: 'POST',
                url: `/api?req=${reqType}&action=fetch`,
                data: data,
                beforeSend: function () {
                    context.commit('SET_SAVING_STATUS', true);
                },
                success: function (res) {
                    console.log('Auto Funnel Fetch: ', res);
                    if (res != null && Object.keys(res).length > 0) {
                        if (res.data && Object.keys(res.data).length > 0) {

                            const syncExec = fs.commitMutations(res.data);
                            const dk = Object.keys(res.data);
                            if (dk.includes('init') && dk.includes('factoryItems')) {
                                context.commit('SET_LOADING_STATUS', false);
                            }

                            if (res.data.rtqReq) {
                                const rtq = new RTQ({ ctx: context });
                                rtq.getRatings({ options: res.data.rtqReq });
                            }
                        }
                        if (res.actions && Object.keys(res.actions).length > 0) {
                            if (!Utils.isEmpty(res.actions.redirect)) {
                                router.push(res.actions.redirect.url).catch(() => { });
                            }
                        }
                    }
                    context.commit('SET_SAVING_STATUS', false);
                },
                error: function (xhr, textStatus, errorThrown) {
                    errorCount++

                    throwError(new Error(`fetch error`), { "errorLocation": "fetch", "xhr": JSON.stringify(xhr), "textStatus": textStatus, "errorThrown": errorThrown, data: JSON.stringify(data), context: context })

                    if (errorCount <= 3) {
                        setTimeout(function () {
                            context.dispatch('fetch', { ctrl: data.ctrl });
                        }, 3000)
                    }
                    else {
                        // Do something here
                    }
                }
            });
        },
        fetchHomePrefill(context, data) {
            const fs = new Funnel({ ctx: context });
            var errorCount = 0
            var cast = ''

            if (fs.isBundle()) {
                cast = '&cast=a-h'
            }

            $.ajax({
                type: 'POST',
                url: `/api?req=home&action=prefill${cast}`,
                data: data,
                beforeSend: function () { },
                success: function (res) {
                    console.log('Home Prefill Fetch: ', res);
                    if (res != null && Object.keys(res).length > 0) {
                        if (res.data && Object.keys(res.data).length > 0) {
                            fs.commitMutations(res.data);
                        }
                        if (res.actions && Object.keys(res.actions).length > 0) {
                            if (!Utils.isEmpty(res.actions.redirect)) {
                                router.push(res.actions.redirect.url).catch(() => { });
                            }
                        }
                    }

                    context.commit('SET_LOADING_STATUS', false)
                },
                error: function (xhr, textStatus, errorThrown) {
                    errorCount++

                    throwError(new Error(`fetchHomePrefill error`), { "errorLocation": "fetchHomePrefill", "xhr": JSON.stringify(xhr), "textStatus": textStatus, "errorThrown": errorThrown, "data": JSON.stringify(data) })

                    if (errorCount <= 3) {
                        setTimeout(function () {
                            context.dispatch('fetchHomePrefill');
                        }, 3000)
                    }
                    else {
                        // Do something here
                    }
                }
            });
        }
    },
    modules: {
        vehicle: VehicleModule,
        driver: DriverModule,
        pet: PetModule,
        rv: RVModule,
        rtqm: RTQModule
    },
    plugins: [
        gtmPlugin
    ]
    // plugins: [createPersistedState()],
});
export default store;